var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    [
      _c("page-header"),
      _c(
        "div",
        { staticClass: "gvl-content px-5 pt-8" },
        [_c("router-view")],
        1
      ),
      _c("page-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }